import Thumbnail from "../thumbnail/Thumbnail";

const Propic = ({className="", src=process.env.PUBLIC_URL+"/default_propic.png", onClick}) => {

    return(
        <Thumbnail
            as={(onClick && "button")}
            className={"border border-black border-5 rounded-circle "+className}
            src={src}
            roundedCircle={true}
            onClick={onClick}
        />
    );
}

export default Propic;